import * as yup from "yup";
import { CPFvalidator } from ".";

export const EMAIL_VALIDATION = yup
  .string()
  .email("Informe um endereço de email válido!")
  .required("E-mail é obrigatório!");

export const PASSWORD_VALIDATION = yup
  .string()
  .required("Uma senha é obrigatória!")
  .min(6, "Informe uma senha com mais de 6 caracteres!");

export const NAME_VALIDATION = yup
  .string()
  .required("Nome é obrigatório!")
  .min(6, "Informe um nome com mais de 6 caracteres!");

export const PHONE_VALIDATION = yup
  .string()
  .required('Telefone é obrigatório!"')
  .min(8, "Telefone inválido!");

export const CPF_VALIDATION = yup
  .string()
  .required("CPF é obrigatório!")
  .test("invalid-cpf", "CPF inválido!", (value) => CPFvalidator(value))
  .min(8, "Informe um CPF com mais de 8 caracteres!");

export const ADDRESS_VALIDATION = yup
  .string()
  .required("Endereço é obrigatório!")
  .min(20, "Informe um endereço com mais de 20 caracteres!");

export const TITLE_VALIDATION = yup
  .string()
  .required("Título é obrigatório!")
  .min(6, "Informe um título com mais de 6 caracteres!");

export const MESSAGE_VALIDATION = yup
  .string()
  .required("Mensagem é obrigatória!")
  .min(10, "Informe uma mensagem com mais de 10 caracteres!");
